import React from "react";

const ScoreCard = ({
  title,
  score,
  explanation,
  theme,
  getScoreColor,
}) => (
  <div className={`${theme.card} rounded-xl shadow-lg border p-6`}>
    <div className="flex items-center justify-between mb-3">
      <h4 className={`font-medium ${theme.text} capitalize text-sm`}>
        {title}
      </h4>
      <span
        className={`text-2xl font-bold bg-gradient-to-r ${getScoreColor(
          score
        )} bg-clip-text text-transparent`}
      >
        {score}
      </span>
    </div>

    <div className="mb-3">
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full bg-gradient-to-r ${getScoreColor(
            score
          )} transition-all duration-1000`}
          style={{ width: `${score * 20}%` }}
        />
      </div>
    </div>

    <p className={`text-sm ${theme.textSecondary} leading-relaxed`}>
      {explanation}
    </p>
  </div>
);

export default ScoreCard